import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import ActionButton from '@/components/misc/ActionButton'
import { Badge } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { faTimes } from '@/lib/fontAwesomePro/regular'

interface Props {
  serviceName: string
  onDelete: () => void
  isDeleting: boolean
}

const ServicePill: React.FC<Props> = ({
  serviceName,
  onDelete,
  isDeleting,
}) => (
  <Badge className="px-2 py-1 text-black" variant="outline" size="lg">
    {serviceName}

    <Tooltip>
      <TooltipTrigger asChild>
        <ActionButton
          isProcessing={isDeleting}
          isProcessingText=""
          variant="plain"
          className="hover:text-destructive ml-1 text-inherit"
          onClick={() => onDelete()}
        >
          <FontAwesomeIcon icon={faTimes} />
        </ActionButton>
      </TooltipTrigger>

      <TooltipContent>Click to remove this service</TooltipContent>
    </Tooltip>
  </Badge>
)

export default ServicePill
